import qs from "qs";

export const createURL = state => `?${qs.stringify(state)}`;